import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ConnectionService } from 'src/app/connection.service';
import { SocketService } from 'src/app/services/socket.service';
import * as Highcharts from 'highcharts';

@Component({
  selector: 'app-transaction-history',
  templateUrl: './transaction-history.component.html',
  styleUrls: ['./transaction-history.component.css']
})
export class TransactionHistoryComponent implements OnInit {
  transactionList: any = {}
  trans: number = 1
  yesterDayTrans: any;
  latestTrans: any;
  totalTxn: any;
  yesterTxn: any;
  todayTxn: any;
  listSR: any;
  transactionAccounts2: any[];
  transactionChartDatas: any;
  transactionElement: any;
  transactionUsersCount: any;

  constructor(private conn: ConnectionService, private router: Router,
    private alert: ToastrService, private socketService: SocketService) { }

  ngOnInit() {
    this.socketTransactions();
    this.dailyTransaction()
  }

  socketTransactions(): any {
    this.socketService.latestBlocks().subscribe((res: any) => {
      if (res == 'latestblocks') {
        this.transactionHistory();
        this.yesterDayTransCounts();
        this.latestTransDetails();
        this.transactionCount()
      }
    });
  }

  transactionCount() {
    this.conn.postUrl('users/transCount', {}).subscribe((res: any) => {
      this.totalTxn = res.data.total
      this.yesterTxn = res.data.yester
      this.todayTxn = res.data.today

    })
  }
  transactionHistory() {
    this.conn.postUrl('users/getAllTransaction', {}).subscribe((res: any) => {
      this.transactionList = res.data
    })
  }

  yesterDayTransCounts() {
    this.conn.postUrl('users/24hrTransaction', {}).subscribe((res: any) => {
      this.yesterDayTrans = res.transData
    })
  }

  latestTransDetails() {
    this.conn.postUrl('users/dashboard-data', {}).subscribe((res: any) => {
      this.latestTrans = res.data[0].totalTxns
    })
  }


  dailyTransaction() {
    this.transactionAccounts2 = []
    this.conn.postUrl('users/transactionChart', { type: 'daily' }).subscribe((transactionChartRes: any) => {
      this.transactionChartDatas = transactionChartRes.data
      let categoriesData = []
      for (let index = 0; index < this.transactionChartDatas.length; index++) {
        this.transactionElement = this.transactionChartDatas[index];
        this.transactionUsersCount = this.transactionElement.usersCount
        var obj = {};
        obj["name"] = this.transactionChartDatas[index].date
        obj["y"] = this.transactionUsersCount;
        this.transactionAccounts2.push(obj)
        this.createPieChart();
      }
    })
  }

  createPieChart() {
    Highcharts.chart('chart-pie', {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie'
      },
      title: {
        text: '',
        style: {
          color: 'black',
        }
      },
      tooltip: {
        pointFormat: '<br>Txn Counts : <b>{point.y}</b><br/>'
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            style: {
              color: 'black'
            }
          },
          // showInLegend: true
        }
      },
      series: [{
        name: 'Transactions',
        colorByPoint: true,
        innerSize: '50%',
        color: 'black',
        data: this.transactionAccounts2
      }]
    } as any);
  }

  copyText(val: string) {
    let selBox = document.createElement('input');
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.alert.success('Copied to the clipboard');
  }
}
